var MuiFormControl = {
  defaultProps: {
    fullWidth: true
  },
  styleOverrides: {
    root: {
      '&.MuiFormControl-root': {
        display: 'flex'
      }
    }
  }
};
export default {
  MuiFormControl: MuiFormControl
};